module.exports = __webpack_public_path__ + "static/media/logo-clean.c28af190.png";